import React, { forwardRef, useEffect, useImperativeHandle } from 'react'
import { Input, Row, Col, DatePicker, Form, Button, Popover } from 'antd'
import { InfoCircleOutlined, SearchOutlined } from '@ant-design/icons'
import CollapseBtn from './CollapseBtn'
import { formatMessageNew } from '@/utils/common'
import SelectAll from './SelectAll'

const { RangePicker } = DatePicker
const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 }
}
const defaultBtnCol = {
  xs: { span: 24 },
  sm: { span: 12 },
  md: { span: 12 },
  lg: { span: 8 },
  xl: { span: 8 },
  xxl: { span: 8 }
}
const SearchBar = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => {
    return {
      getInfo: () => {
        return initForm.validateFields()
      },
      clearForm: keys => {
        initForm.resetFields(keys)
      },
      getValue: keys => {
        return initForm.getFieldsValue(keys)
      },
      setValue: obj => {
        initForm.setFieldsValue(obj)
      },
      getSearchValue: key => {
        // 折叠/展开筛选条件时，新增的方法
        const currentFieldsValue = initForm.getFieldValue()
        if (filterIsCollapse && lastFieldsValue) {
          return { ...lastFieldsValue, ...currentFieldsValue }
        } else {
          return currentFieldsValue
        }
      }
    }
  })
  const [initForm] = Form.useForm()
  const { searchList = [], layout, showCollapseBtn, showSearchBtn, showClearBtn, btnCol = defaultBtnCol } = props

  const [filterIsCollapse, setFilterIsCollapse] = React.useState(true)
  const [defaultSearchList, setDefaultSearchList] = React.useState([])
  const [fieldList, setFieldList] = React.useState(searchList)
  const [defaultFieldsValue, setDefaultFieldsValue] = React.useState(null)
  const [lastFieldsValue, setLastFieldsValue] = React.useState(null)

  useEffect(() => {
    const defaultSearchList = searchList.filter(item => item.isdefaultfilter === 'true')
    setDefaultSearchList(defaultSearchList)
    if (showCollapseBtn && filterIsCollapse) {
      const defaultFieldsValue = initForm.getFieldValue()
      setDefaultFieldsValue(defaultFieldsValue)
      setFieldList(defaultSearchList)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onCollapseFilter = () => {
    const fieldsValue = initForm.getFieldsValue()
    setFilterIsCollapse(true)
    setFieldList(defaultSearchList)
    setLastFieldsValue(fieldsValue)
  }

  const onExpandFilter = () => {
    setFilterIsCollapse(false)
    setFieldList(searchList)
    setLastFieldsValue(null)
  }

  const onSearch = () => {
    props.onSearch && props.onSearch()
  }

  const onClear = () => {
    initForm.resetFields()
    if (showCollapseBtn && filterIsCollapse) {
      setLastFieldsValue(defaultFieldsValue)
    }
    props.onClear && props.onClear()
  }

  const checkallChange = (ls, key) => {
    initForm.setFieldValue(key, ls)
  }
  return (
    <>
      <Form form={initForm} style={{ width: '100%' }} colon={false} {...(layout || formItemLayout)}>
        <Row type="flex" gutter={[0, 8]}>
          {fieldList.map((item, idx) => {
            let {
              type,
              label,
              key,
              refValue,
              returnCallback,
              placeholder,
              initialValues,
              handleChange,
              selectList,
              selectAllClear,
              multipleLimit,
              spans,
              remove,
              minRows,
              maxRows,
              ...resItem
            } = item
            if (remove) {
              selectList = selectList.filter(filterItem => filterItem.value !== remove)
            }
            let resDom = <span></span>
            switch (type) {
              case 'input':
                resDom = (
                  <Input
                    allowClear
                    ref={refValue}
                    placeholder={
                      placeholder ? placeholder : formatMessageNew('languageObj.commonLocale.placeholderInput')
                    }
                    onChange={e => handleChange && handleChange(e, idx, item)}
                    disabled={item.disabled}
                    // {...resItem}
                    onKeyUp={e => returnCallback && returnCallback(e)}
                  />
                )
                break
              case 'textarea':
                resDom = (
                  <Input.TextArea
                    allowClear={item.allowClear}
                    ref={refValue}
                    autoSize={{ minRows: minRows || 2, maxRows: maxRows || 6 }}
                    placeholder={
                      placeholder ? placeholder : formatMessageNew('languageObj.commonLocale.placeholderInput')
                    }
                    onChange={e => handleChange && handleChange(e, idx, item)}
                    disabled={item.disabled}
                    // {...resItem}
                    onKeyUp={e => returnCallback && returnCallback(e)}
                  />
                )
                break
              case 'select':
                let allowClearFlag = selectAllClear || false
                let showAllFlag = false
                if (item.mode === 'multiple') {
                  allowClearFlag = true
                  showAllFlag = true
                }
                // showAll取值范围："true"、"false"，注意要带引号
                if (item.showAll) {
                  showAllFlag = Boolean(item.showAll)
                }
                resDom = (
                  <SelectAll
                    formValues={initForm.getFieldValue()}
                    selectAllBack={e => {
                      checkallChange(e, key)
                      handleChange && handleChange(e, idx, item)
                    }}
                    allowClearFlag={allowClearFlag}
                    showAll={showAllFlag}
                    initialValues={initialValues}
                    selectList={selectList}
                    selectKey={key}
                    {...resItem}
                  ></SelectAll>
                )
                // resDom = (
                //   <Select
                //     showSearch
                //     style={{ width: '100%' }}
                //     // className='nike_select'
                //     placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
                //     onChange={e => handleChange && handleChange(e, idx, item)}
                //     optionFilterProp="children"
                //     filterOption={(input, option) =>
                //       option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                //     }
                //     allowClear={allowClearFlag}
                //     {...resItem}
                //   >
                //     {selectList.map((itemSel, idxSel) => {
                //       return (
                //         <Select.Option key={idxSel} value={itemSel.value}>
                //           {itemSel.label}
                //         </Select.Option>
                //       )
                //     })}
                //   </Select>
                // )
                break
              case 'selectSpc':
                let allowClearFlagSpc = selectAllClear || false
                let showAllFlagSpc = false
                // showAll取值范围："true"、"false"，注意要带引号
                if (item.showAll) {
                  showAllFlagSpc = Boolean(item.showAll)
                }
                resDom = (
                  <SelectAll
                    formValues={initForm.getFieldValue()}
                    selectAllBack={e => {
                      checkallChange(e, key)
                      handleChange && handleChange(e, idx, item)
                    }}
                    allowClearFlag={allowClearFlagSpc}
                    showAll={showAllFlagSpc}
                    initialValues={initialValues}
                    selectList={selectList}
                    selectKey={key}
                    {...resItem}
                  >
                    <Popover
                      content={
                        <div>
                          <p>
                            • Source-missing UID: UID does not exist in the system or was disabled before but has
                            operation records from WMS.
                          </p>
                          <p>
                            • Non-Tagged/Disabled Return UID: UID does not have tagging history or has been disabled but
                            is being validated in WMS.
                          </p>
                          <p>
                            • Duplicate Return UID &lt;=48 Hrs: Multiple return records (&gt;= 5 times) for the same UID
                            within the past 48 hours.
                          </p>
                        </div>
                      }
                      trigger="click"
                    >
                      <InfoCircleOutlined style={{ marginLeft: 8, color: 'black', cursor: 'pointer' }} />
                    </Popover>
                  </SelectAll>
                )
                break
              case 'timeRange':
                resDom = (
                  <RangePicker
                    format={item.format}
                    onChange={e => handleChange && handleChange(e, idx, item)}
                    {...resItem}
                  />
                )
                break
              case 'timeRangeSpc':
                resDom = (
                  <RangePicker
                    showTime={{ format: 'HH:mm' }}
                    format={item.format || 'YYYY-MM-DD HH:mm'}
                    onChange={e => handleChange && handleChange(e, idx, item)}
                    {...resItem}
                  />
                )
                break
              case 'html':
                resDom = item.htmlDom
                break

              default:
                resDom = <span></span>
                break
            }
            return (
              <Col key={idx} xs={24} sm={12} md={12} lg={8} xl={6} xxl={4} {...spans}>
                {label ? (
                  <Row type="flex" justify="space-between" align="middle">
                    <Form.Item
                      label={formatMessageNew(label) || label}
                      name={key}
                      initialValue={initialValues}
                      style={{ width: '100%', margin: 0 }}
                      className="search_form_label"
                    >
                      {resDom}
                    </Form.Item>
                  </Row>
                ) : (
                  resDom
                )}
              </Col>
            )
          })}
          {(showCollapseBtn || showSearchBtn || showClearBtn) && (
            <Col {...btnCol} className="right_search" style={{ justifyContent: 'flex-end' }}>
              {showCollapseBtn && (
                <CollapseBtn
                  filterIsCollapse={filterIsCollapse}
                  onCollapseFilter={onCollapseFilter}
                  onExpandFilter={onExpandFilter}
                />
              )}
              {showSearchBtn && (
                <Button icon={<SearchOutlined />} type="primary" onClick={onSearch}>
                  {formatMessageNew('languageObj.commonLocale.search')}
                </Button>
              )}
              {showClearBtn && <Button onClick={onClear}>{formatMessageNew('languageObj.commonLocale.clear')}</Button>}
            </Col>
          )}
          {props.children}
        </Row>
      </Form>
    </>
  )
})
export default React.memo(SearchBar)
